<template>
    <div class="appraisal-page">
        <div class="container-fluid mt-1">
            <div class="row">
                <div class="col-xl-8 mb-5 mb-xl-0">
                <question-list
                    :quizId="quizId"
                ></question-list>
                </div>
                <div class="col-xl-4">
                    <div v-if="!viewQuizDetail" class="card" >
                        <div class="card-header row align-items-center bg-transparent">
                            <div class="col">
                                <h6 class="text-uppercase ls-1 mb-1">Info</h6>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="identity px-2">
                                <p class="line-with-icon"><i class="clr-red fa fa-user" aria-hidden="true"></i>{{overview.user_name}}</p>
                                <p class="line-with-icon"><i class="clr-red fa fa-user" aria-hidden="true"></i>{{overview.user_status}}</p>
                                <p class="line-with-icon"><i class="clr-red fa fa-book" aria-hidden="true"></i>{{overview.subject_name}}</p>
                                <p class="line-with-icon"><i class="clr-red fa fa-folder-open" aria-hidden="true"></i>{{overview.name}}</p>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="card">
                                <div class="card-body text-center">
                                    <h6>{{overview.total_quiz}}</h6>
                                    <h6>Total Penilaian</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <appraisal-detail
                        v-else
                        :quizId="quizId"
                        :appraisalType="appraisalType"
                    ></appraisal-detail>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { EventBus } from '@/eventBus.js'
    import QuestionList from "../../../components/Main/Appraisal/QuestionList";
    import AppraisalDetail from "../../../components/Main/Appraisal/AppraisalDetail";
	export default {
        components: {
            QuestionList,
            AppraisalDetail
        },
        data() {
            return {
                modulId: this.$route.params.modulId,
                quizId: this.$route.params.quizId,
                table: {
                    fields: [
                        { key: 'name', label: 'Name', class: 'task-name text-left'  },
                        { key: 'actions', label: 'Actions', class: 'action-column' }
                    ],
                },
                viewQuizDetail: 1,
            }
        },
        computed: {
            ...mapGetters({
                user: 'getUser',
                overview: 'getAppraisalOverview',
                appraisalType: 'getAppraisalType'
            })
        },
        methods: {
            showAppraisalFormModal() {
                this.$refs['appraisal-form-modal'].show()
            },
            hideAppraisalFormModal() {
                this.$refs['appraisal-form-modal'].hide()
                this.resetAppraisalForm()
            },
            resetAppraisalForm() {
                EventBus.$emit('resetAppraisalForm', true)
            },
			async getAppraisalType() {
				await this.$store.dispatch('getAppraisalType')
			},
			async getAppraisalOverview() {
                let modulId = this.$route.params.modulId
				await this.$store.dispatch('getAppraisalOverview', { modulId })
					.then(() => {
					})
					.catch((err)=> {
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			},
			async confirmDeleteAppraisal(appraisalId) {
                this.$swal.fire({
                    title: 'Apakah anda yakin?',
                    text: '',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ya, saya yakin',
                    cancelButtonText: 'Tidak'
                }).then((result) => {
                    if (result.value) {
                        this.deleteAppraisal(appraisalId)
                    }
                })
			},
            async deleteAppraisal(id) {
				await this.$store.dispatch('deleteAppraisal', { id })
					.then((res) => {
                        this.getAppraisalOverview()
                        this.$swal.fire('Success', res.message, 'success')
					})
					.catch((err)=> {
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
            },
            hideDetail() {
                this.$nextTick(() => {
                    this.viewQuizDetail = false
                });
            },
            reDoExams(param) {
                this.$swal.fire({
                    title: 'Perhatian!',
                    text: 'Apakah anda yakin akan mengerjakan kembali penilaian hasil belajar?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ya, saya yakin',
                    cancelButtonText: 'Tidak'
                }).then((result) => {
                    if (result.value) {
                        let appraisalId = param.id
                        this.$router.push({ name: 'appraisal-test', params: { appraisalId: appraisalId }  })
                    }
                })
            },
            doExams(param) {
                this.$swal.fire({
                    title: 'Perhatian!',
                    html: 'Apakah anda yakin akan mengerjakan penilaian <b>'+ param.name +'</b>?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ya, saya yakin',
                    cancelButtonText: 'Tidak'
                }).then((result) => {
                    if (result.value) {
                        let appraisalId = param.id
                        this.$router.push({ name: 'appraisal-test', params: { appraisalId: appraisalId }  })
                    }
                })
            }
        },
        async created() {
            await this.setCurrentModulId(this.$route.params.modulId)
            await this.getAppraisalOverview()
            await this.getAppraisalType()
			EventBus.$on('hideAppraisalFormModal', (val) => {
				if (val) {
					this.hideAppraisalFormModal()
				}
			})
			EventBus.$on('hideDetail', (val) => {
				if (val) {
					this.hideDetail()
				}
			})
        }
    }
</script>
<style lang="css" scoped>
.btn-primary {
    color: #fff;
    background-color: #ca062a;
    border-color: #ca062a;
}
.table-responsive {
    margin-bottom: 0;
}
.btn-primary:hover, .btn-primary:not(:disabled):not(.disabled):active, .btn-primary:focus {
    color: #fff;
    background-color: #ca062a;
    border-color: #ca062a;
    -webkit-box-shadow: unset;
    box-shadow: unset;
}
</style>